import { useDispatch } from 'react-redux';
import { useAppSelector } from '~/hooks';
import { BackButton, CardSpinner } from '~/commonComponents';
import { POST_PP_JOB, postPermanentHireJob } from '../../../actions';
import { createLoadingSelector } from '../../../api/selectors';
import PPView from './PPView';

export default function PPScreen() {
  const loadingSelector = createLoadingSelector([POST_PP_JOB]);
  const isLoading = useAppSelector((state) => loadingSelector(state));
  const dispatch = useDispatch();

  if (isLoading) {
    return <CardSpinner />;
  }
  return (
    <div className="component_container">
      <div className="floating_container" style={{ flexDirection: 'column' }}>
        <div style={{ marginTop: 20, marginLeft: 30 }}>
          <BackButton />
        </div>

        <PPView btnSubmitClicked={(jobData) => dispatch(postPermanentHireJob({ jobData }))} />
      </div>
    </div>
  );
}
